























import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IntroOneIdPanel extends Vue {}
